module.exports = __webpack_public_path__ + "img/mediaDownload.ee0dfc8a.png";